module.exports = __webpack_public_path__ + "static/media/iconcoachingcall-copy-3-grey.acc46155.svg";